import { ProFormRadio } from '@ant-design/pro-components'
import type React from 'react'
import { EditableLabel } from '../components/EditableLabel'
import { EditableShell } from '../components/EditableShell'
import { useFieldContext } from '../createAppFormHook'
import { useEditableFieldMode } from '../hooks/useEditableFieldMode'
import { useMergedFieldProps } from '../utils/mergeFieldProps'

export type RadioFieldProps = React.ComponentProps<typeof ProFormRadio>

export function RadioField<TValue = string | number | boolean>(props: RadioFieldProps) {
  const fieldCtx = useFieldContext<TValue>()
  const { formItemProps, fieldProps, proFieldProps, className, ...rest } = props

  const editable = useEditableFieldMode<TValue>()

  const merged = useMergedFieldProps({
    fieldCtx,
    editable,
    props,
    fieldDefaults: {
      fieldProps: {
        onChange: (e: unknown) => {
          const v = (e as { target?: { value?: unknown } }).target?.value ?? e
          fieldCtx.handleChange(v as TValue)
        },
      },
    },
  })

  return (
    <EditableShell
      mode={editable.mode}
      enterEdit={editable.enterEdit}
      exitRead={editable.exitRead}
      className={className}
    >
      <ProFormRadio
        {...rest}
        label={
          <EditableLabel
            mode={editable.mode}
            enterEdit={editable.enterEdit}
            exitRead={editable.exitRead}
            onUndo={editable.undoAndExit}
            canUndo={editable.canUndo}
          >
            {rest.label}
          </EditableLabel>
        }
        proFieldProps={merged.proFieldProps}
        formItemProps={merged.formItemProps}
        fieldProps={merged.fieldProps}
      />
    </EditableShell>
  )
}
